import uniq from "lodash/uniq";
import { decodeDelimitedArray, encodeDelimitedArray } from "serialize-query-params";

import { isPresent } from "~/tools/is-present";

export const encodeUniqDelimitedArray = (
	array: null | undefined | Array<null | string>,
	separator: string,
): null | undefined | string => {
	if (array == null) {
		return array;
	}

	return encodeDelimitedArray(uniq(array), separator);
};

export const decodeUniqDelimitedArray = (
	input: null | undefined | string | Array<null | string>,
	separator: string,
): undefined | Array<string> => {
	const result = decodeDelimitedArray(input, separator)?.filter(isPresent);

	if (result == null) {
		return undefined;
	}

	return uniq(result);
};
